
import * as Data from "@/../src-gen/data";
import MDP from "../MDP";
import FBtnMDP from "../FBtnMDP";
import FFieldMDP from "./field/FFieldMDP";

export class FFormChildMDP {
  outlined = true;
  dense = true;
  boundaryClass = "col-sm-3";

}

export default class FFormMDP implements MDP {
  componentName = "FForm";
  fieldList: FFieldMDP[] = [];
  actionList: FBtnMDP[] = [];
  myRefName: string;
  dataSelectorKey: string | undefined;
  disabled: boolean;
  readonly: boolean;
  hideOutlineForReadOnly?: boolean;
  colWidth: number;
  onSubmit?: (actionMetaData: any) => any;
  showActionNewLine?: boolean = true;

  confirmationInfo?: ConfirmationInfo;

  constructor({
    myRefName,
    dataSelectorKey,
    disabled = false,
    colWidth = 12,
    readonly=false,
    onSubmit,
    confirmationInfo,
    hideOutlineForReadOnly=false,
    showActionNewLine=true
  }: {
    myRefName: string;
    dataSelectorKey?: string;
    disabled?: boolean;
    colWidth?: number;
    readonly?: boolean;
    onSubmit?: (actionMetaData: any) => any;
    confirmationInfo?: ConfirmationInfo;
    hideOutlineForReadOnly?: boolean;
    showActionNewLine?: boolean;
  }) {
    this.myRefName = myRefName;
    this.dataSelectorKey = dataSelectorKey;
    this.disabled = disabled
    this.colWidth = colWidth;
    this.readonly = readonly;
    this.onSubmit = onSubmit;
    this.confirmationInfo = confirmationInfo;
    this.hideOutlineForReadOnly = hideOutlineForReadOnly;
    this.showActionNewLine = showActionNewLine
  }

  addField(newField: FFieldMDP) {
    this.fieldList.push(newField);
    return this;
  }

  addAction(newAction: FBtnMDP) {
    this.actionList.push(newAction);
    return this;
  }

  getFFormBoundaryClass() {
    return `col-${this.colWidth}`
  }

  getMetaData(): object {
    return {
      myRefName: this.myRefName,
      componentName: this.componentName,
      dataSelectorKey: this.dataSelectorKey,
      props: {
        myRefName: this.myRefName,
        fieldMetaDataList: this.fieldList.map((field) => field.getMetaData()),
        actionMetaDataList: this.actionList.map((action) =>
          action.getMetaData()
        ),
        disabled: this.disabled,
        boundaryClass: this.getFFormBoundaryClass(),
        readonly: this.readonly,
        onSubmit: this.onSubmit,
        confirmationInfo:this.confirmationInfo,
        hideOutlineForReadOnly: this.hideOutlineForReadOnly,
        showActionNewLine: this.showActionNewLine
      },
    };
  }



  getNewClass() {
    const newForm = new FFormMDP({ myRefName: this.myRefName,  disabled: this.disabled, readonly: this.readonly,confirmationInfo: this.confirmationInfo,onSubmit: this.onSubmit});
    newForm.actionList = this.actionList;
    newForm.fieldList = this.fieldList;

    return newForm;
  }
}

export interface ConfirmationInfo {
  message: string;
  matchingParam?:any;
  
}
